<!--
 * @Description: 登录组件
 * @Author: hai-27
 * @Date: 2020-02-19 20:55:17
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-01 15:34:08
 -->
<template>
  <div id="myLogin">
    <el-dialog :title="$t('login.title')" width="360px" center :visible.sync="isLogin">
      <el-form :model="LoginUser" :rules="rules" status-icon ref="ruleForm" class="demo-ruleForm">
        <el-form-item prop="name">
          <el-input prefix-icon="el-icon-user-solid" :placeholder="$t('login.username')" v-model="LoginUser.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input
            prefix-icon="el-icon-view"
            type="password"
            :placeholder="$t('login.password')"
            v-model="LoginUser.pass"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-agreement-item">
          <el-checkbox v-model="agreed">
            <span class="agreement-text">
              {{ $t('login.agreePrefix') }}
              <router-link class="agreement-link" to="/service-refund">{{ $t('login.serviceAgreementLink') }}</router-link>
              {{ $t('login.agreeAnd') }}
              <router-link class="agreement-link" to="/privacy">{{ $t('login.privacyPolicyLink') }}</router-link>
            </span>
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" type="primary" @click="Login" style="width:100%;">{{ $t('login.button') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  name: "MyLogin",
  data() {
    return {
      agreed: false,
      LoginUser: {
        name: "",
        pass: ""
      },
      rules: {
        name: [{ validator: this.validateName, trigger: "blur" }],
        pass: [{ validator: this.validatePass, trigger: "blur" }]
      }
    };
  },
  computed: {
    isLogin: {
      get() {
        return this.$store.getters.getShowLogin;
      },
      set(val) {
        if (this.$refs["ruleForm"]) {
          this.$refs["ruleForm"].resetFields();
        }
        this.agreed = false;
        this.setShowLogin(val);
      }
    }
  },
  methods: {
    ...mapActions(["setUser", "setShowLogin"]),
    validateName(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('login.usernameRule')));
      }
      const userNameRule = /^[a-zA-Z][a-zA-Z0-9_]{4,15}$/;
      if (userNameRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error(this.$t('login.usernameRuleError')));
      }
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        return callback(new Error(this.$t('login.passwordRule')));
      }
      const passwordRule = /^[a-zA-Z]\w{5,17}$/;
      if (passwordRule.test(value)) {
        this.$refs.ruleForm.validateField("checkPass");
        return callback();
      } else {
        return callback(new Error(this.$t('login.passwordRuleError')));
      }
    },
    Login() {
      if (!this.agreed) {
        this.notifyError(this.$t('login.agreeRequired'));
        return;
      }
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$axios
            .post("/api/users/login", {
              userName: this.LoginUser.name,
              password: this.LoginUser.pass
            })
            .then(res => {
              if (res.data.code === "001") {
                this.isLogin = false;
                let user = JSON.stringify(res.data.user);
                localStorage.setItem("user", user);
                this.setUser(res.data.user);
                this.notifySucceed(this.$t('login.success'));
              } else {
                this.$refs["ruleForm"].resetFields();
                this.notifyError(res.data.msg);
              }
            })
            .catch(err => {
              return Promise.reject(err);
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style scoped>
.login-agreement-item {
  margin-bottom: 8px;
}
.login-agreement-item >>> .el-form-item__content {
  line-height: 1.5;
}
.agreement-text {
  font-size: 13px;
  color: #909399;
  white-space: normal;
  vertical-align: middle;
}
.agreement-link {
  color: #ff6700;
}
.agreement-link:hover {
  color: #ff8533;
}
@media (max-width: 768px) {
  #myLogin .el-dialog {
    width: 90% !important;
    max-width: 360px;
  }
}
</style>
